import React from 'react';

const AssetDevelopment = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <p>
          We have a strong track record of executing projects on time and within budget. We take special care to develop
          the resource base to optimise production and increase the life of the resource. We also strategically develop
          processing facilities.
        </p>
      </div>
    </div>
  );
};

export default AssetDevelopment;
